module.exports = __webpack_public_path__ + "static/media/033-superhero.bf76fa4d.svg";